<template>
    <v-container>
        <v-row
            align="center"
            justify="center"
        >
            <v-col cols="8">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        Crear Red Continua
                    </v-card-subtitle>
                    <v-card-text>
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                        >
                            <v-col cols="12">
                                <v-text-field
                                    v-model="name"
                                    outlined
                                    dense
                                    clearable
                                    label="Nombre Red Continua"
                                    hint="Nombre Red Continua"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-combobox
                                    v-model="select"
                                    :items="devices"
                                    item-value="deviceId"
                                    item-text="name"
                                    label="Dispositivos"
                                    outlined
                                    multiple
                                    chips
                                ></v-combobox>
                            </v-col>
                             <v-btn
                                color="green"
                                outlined
                                @click="createProject"
                                :disabled="!valid"
                            >
                                Crear
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
	import moment from 'moment'

	export default {
        name: 'CreateUser',
        

		data: () => ({
            name: '',
            valid: false,
            select: [],
            items: [
                'Programming',
                'Design',
                'Vue',
                'Vuetify',
            ],
		}),

		methods: {
            createProject () {
                 let payload = {
                    name: this.name,
                    devices: []
                }

                this.select.forEach( e => {
                    payload.devices.push(e.deviceId)
                })

                const isValid = this.$refs.form.validate()

                if (isValid)
                    this.$store.dispatch('createProject', payload)
            }
		},

		computed: {
            devices () {
                return this.$store.getters.devices.filter( e => {
                    return e.projectId === undefined
                })
            },
            projects () {
                return this.$store.getters.projects
            },
		},

		created () {
			moment.locale('es-us')
		}

	}
</script>
